import React, { useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { AuthRoutes } from '@klpkonsern/auth-core/routes';
import { SakAdd, SakConfirmation } from '@klp/sak';
import { SakRoutes } from '@klp/sak/config';
import { SupportFormRoutes } from '@klp/supportapplicationform/config';
import {
    ApplicationFormAdd,
    ApplicationFormView,
} from '@klp/supportapplicationform/views';

import {
    LoginView,
    AuthCallbackView,
    LogoutView,
    SilentCallbackView,
    useCurrentUser,
} from '../auth';

export const UnauthorisedRoutes: React.FC = () => {
    const { currentUserIsLoading, isAuthenticated } = useCurrentUser();
    const { pathname, hash } = useLocation();

    const hasUnmounted = useRef(false);

    useEffect(() => {
        return () => {
            hasUnmounted.current = true;
        };
    }, []);

    if (hasUnmounted.current) return null; // No render if component has unmounted
    if (currentUserIsLoading) return null; // Wait for user data to load, authorization is not determined yet
    if (isAuthenticated) return null; // User is already authenticated, no need to process anything here

    return (
        <Switch>
            <Route
                path={AuthRoutes.mainLogin}
                exact={true}
                render={() => <LoginView />}
            />
            <Route path={AuthRoutes.login} exact={true} component={LoginView} />
            <Route
                path={AuthRoutes.authCallback}
                exact={true}
                component={AuthCallbackView}
            />
            <Route
                path={AuthRoutes.authSilentCallback}
                exact={true}
                component={SilentCallbackView}
            />
            <Route
                path={AuthRoutes.logout}
                exact={true}
                component={LogoutView}
            />
            <Route
                path={SupportFormRoutes.form()}
                exact={true}
                component={ApplicationFormAdd}
            />
            <Route
                path={SupportFormRoutes.formAdd(':formId')}
                exact={true}
                component={ApplicationFormAdd}
            />
            <Route
                path={SupportFormRoutes.formView(':formId')}
                exact={true}
                component={ApplicationFormView}
            />
            <Route
                path={SupportFormRoutes.formView()}
                exact={true}
                component={ApplicationFormView}
            />
            <Route path={SakRoutes.add()} exact={true} component={SakAdd} />
            <Route
                path={SakRoutes.confirmation()}
                exact={true}
                component={SakConfirmation}
            />

            <Redirect
                to={{
                    pathname: AuthRoutes.login,
                    state: { referrer: `${pathname}${hash}` },
                }}
            />
        </Switch>
    );
};
